import React from 'react';

const BannerNotice = ({ label, text, linkText, linkHref, tone }) => (
  <div className={`row banner-notice${tone ? ` banner-notice-${tone}` : ''}`}>
    <div className="col-12">
      <h3>
        <span className="banner-label">{label}</span>
        {text}
        {linkHref && (
          <a className="banner-link" href={linkHref} target="_blank" rel="noopener noreferrer">
            {linkText || 'Learn more'}
          </a>
        )}
      </h3>
    </div>
  </div>
);

export const AppBanner = ({ notices = [] }) => {
  if (notices.length === 0) {
    return null;
  }
  return (
    <div className="container-fluid app-banner">
      {notices.map((notice, index) => (
        <BannerNotice key={index} {...notice} />
      ))}
    </div>
  );
};
